import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/provider/$providerId/team')({
  head: () => ({ meta: [{ title: 'Team' }] }),
  component: Outlet,
});
